export default "__VITE_ASSET__CY2kqtC1__"